import { render, staticRenderFns } from "./WashcareDialogue.vue?vue&type=template&id=33786d86&"
import script from "./WashcareDialogue.vue?vue&type=script&lang=ts&"
export * from "./WashcareDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports